// extracted by mini-css-extract-plugin
export default {"ImportantInfoModal":"W5skUH","info":"mauLax","NORMAL":"wm5WcN","STRONG":"i427mi","VERY_STRONG":"sJ0Bra","recently-changed":"ayBB4z"};